const initalState = null


const tabmenuChangeReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "SET_TABMENU_CHANGE":
			return data
		
		default:
			return state
	}
}

const latestDrawingReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "ADD_LATEST_DRAWING":
			return data
		
		default:
			return state
	}
}

const drawingPropertyReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "ADD_DRAWING_PROPERTY":
			return data
		
		default:
			return state
	}
}

const fileUploadingPropertyReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "ADD_FILE_UPLOADING_PROPERTY":
			return data
		
		default:
			return state
	}
}



const unpublishPacksReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "ADD_UNPUBLISH_PACKS":
			return data
		
		default:
			return state
	}
}


const unpublishDetailReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "ADD_UNPUBLISH_DETAIL":
			return data
		
		default:
			return state
	}
}


const relatedItemPropertyReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "ADD_RELATED_ITEM":
			return data
		
		default:
			return state
	}
}



export {
	tabmenuChangeReducer,
	

	latestDrawingReducer,
	drawingPropertyReducer,
	fileUploadingPropertyReducer,
	unpublishPacksReducer,
	unpublishDetailReducer,
	relatedItemPropertyReducer

	
}